<template>
  <FlotoModule>
    <RouterView :key="$route.fullPath" />
  </FlotoModule>
</template>

<script>
import Constants from '@constants'
import { CategoryMethods } from '@state/modules/category'

export default {
  name: 'CategoryModule',
  page() {
    return {
      title: this.$tc('category', 2),
    }
  },
  beforeRouteEnter(to, from, next) {
    const allowedForms = [
      Constants.REQUEST,
      Constants.PROBLEM,
      Constants.CHANGE,
      Constants.RELEASE,
      Constants.ASSET,
    ]
    if (
      to.params.moduleName &&
      allowedForms.indexOf(to.params.moduleName) === -1
    ) {
      return next({ name: '404' })
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    // add any module level clean up logic here
    const moduleName = from.params.moduleName || this.$constants.REQUEST
    this[`${moduleName}CategoriesFetch`]()
    this.categoryConfigFetch()
    next()
  },
  methods: {
    ...CategoryMethods,
  },
}
</script>
